import { createStyles } from "@mantine/emotion";

import { rooterMediaQuery } from "_styles/theme/mediaQuery";

export default createStyles ( ( theme, props ) => {

	return {
		nameContainer: {
			maxWidth : theme.other.isApple ? "90%" : "unset",
			width    : "max-content",
			display  : "flex",
			padding  : "0 7px 0 7px",
			overflow : "hidden"
		},
		topContainer: {
			// position           : "absolute",
			// bottom             : "7.8rem",
			// paddingTop : "10px",
			// background      : "#fff",
			padding    : "10px 0 2px 10px",
			display    : theme.other.isApple ? "-webkit-box" : "flex",
			width      : "100%",
			fontSize   : "12px",
			alignItems : "flex-start",
			borderTop  : `1px solid ${ theme.other.colors.border.primary }`,

			[rooterMediaQuery.mobile]: {
				background: theme.other.colors.dialog.secondary
			}
			// boxShadow          : "0px -4px 2px 1px rgba(255, 255, 255, 0.6)",
			// backgroundImage : "linear-gradient(to bottom, rgba(255, 255, 255, 0), #fff)"
		},
		// topContainer: {
		// display          : isApple ? "-webkit-box" : "flex",
		// margin           : "0 0 10px 10px",
		// width            : "100%",
		// fontSize         : "12px",
		// alignItems       : "flex-start"
		// },

		userName: {
			cursor     : "pointer",
			color      : "#757575",
			fontWeight : "500",
			wordBreak  : "break-word"
		},
		avatar: {
			height       : "30px",
			width        : "30px",
			objectFit    : "cover",
			borderRadius : "50%"
		},
		commentContainer: {
			padding       : "1rem 1rem 1rem 0",
			display       : "flex",
			flexDirection : "column-reverse",
			overflow      : "auto",
			overflowX     : "hidden",
			position      : "absolute",
			width         : "100%",
			height        : "100%"
		},
		showOptionsButton: {
			display    : "block",
			height     : "22px",
			width      : "22px",
			cursor     : "pointer",
			marginLeft : "10px"
		},
		hideOptionsButton: {
			display: "hidden"
		},
		svgIcon: {
			height       : "22px",
			width        : "22px",
			marginBottom : "0.5rem"
		},
		iconContainer: {
			display    : "inline-flex",
			lineHeight : 1,
			cursor     : "pointer"
		},
		svgTagsIcon: {
			minHeight : "20px !important",
			minWidth  : "50px !important",
			cursor    : "pointer"
		},
		tagPosition: {
			paddingLeft : "0.7rem",
			margin      : "-0.2rem"
		},
		commentHeader: {
			display        : "flex",
			flexDirection  : "row",
			justifyContent : "space-between",
			alignItems     : "flex-start",
			marginBottom   : "5px"
		},
		comment: {
			color: theme.other.colors.text.primary
		},
		tags: {
			height : "17px",
			width  : "auto"
		},
		emoteContainer: {
			display       : "inline-flex",
			verticalAlign : props?.isFireFox ? "-moz-middle-with-baseline" : "-webkit-baseline-middle",
			marginTop     : "-0.6rem",
			width         : "20px"
		},
		emote: {
			height: "20px"
		},
		readOrHide: {
			textAlign  : "left",
			fontSize   : "13px",
			color      : "#757575",
			fontWeight : "500",
			cursor     : "pointer"
		},
		profileLink: {
			all: "unset"
		}
	};
} );

